import React, { FC, useState, useEffect } from 'react';
import Lottie from 'react-lottie-player';
import iconKey from 'src/assets/bodymovin/iconKey.json';
import './style.scss';

interface Props {
  inputType: string;
  styleDef?: { height: string };
  iconType: string;
  placeHolder: string;
  btnClickEvt: (mode: string) => void;
  inpRef: any;
}

interface lottieProps {
  loop: boolean;
  speed: number;
  play: boolean;
  direction: 1 | -1;
  segments: [number, number];
}

const InputConfirmBox: FC<Props> = ({
  styleDef = {},
  iconType = '',
  inputType,
  placeHolder,
  btnClickEvt,
  inpRef,
}) => {
  // const boxStyle = { height: styleDef.height };
  const [lottieState, setLottieState] = useState<lottieProps>({
    loop: false,
    speed: 1,
    play: false,
    direction: 1,
    segments: [0, 0],
  });
  const [textState, setTextState] = useState({ txt: '', btnActive: false });

  const onChangeEvt = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTextState({ ...textState, txt: e.target.value });
  };

  useEffect(() => {
    if (textState.txt.trim() !== '') {
      activeCode();
      setTextState({ ...textState, btnActive: true });
    } else {
      closeCode();
      setTextState({ ...textState, btnActive: false });
    }
  }, [textState.txt]);

  useEffect(() => {
    if (iconType === 'fail') {
      failCode();
      setTextState({ ...textState, btnActive: false });
    }
  }, [iconType]);

  // lottie
  const addLog = (v: string) => {};
  const activeCode = () => {
    if (!textState.btnActive) {
      setLottieState({
        ...lottieState,
        loop: false,
        segments: [25, 48],
        play: true,
        direction: 1,
      });
    }
  };
  const closeCode = () => {
    setLottieState({
      ...lottieState,
      loop: false,
      play: true,
      segments: [5, 5],
      direction: -1,
    });
  };
  const failCode = () => {
    setLottieState({
      ...lottieState,
      loop: false,
      play: true,
      segments: [60, 74],
      direction: 1,
    });
  };

  const onKeydownEvt = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && e.nativeEvent.isComposing === false) {
      sendEvent();
    }
  };
  const sendEvent = () => {
    btnClickEvt('confirm');
  };
  return (
    <>
      <div className="_atoms_input_confirm_box">
        <div className="_inp_content">
          <div className="_inp_div">
            <input
              value={textState.txt}
              type={inputType}
              placeholder={placeHolder}
              onChange={e => onChangeEvt(e)}
              onKeyPress={e => onKeydownEvt(e)}
              autoComplete="off"
              ref={inpRef}
            />
            <div className="_btn" onClick={sendEvent}>
              <Lottie
                loop={lottieState.loop}
                speed={lottieState.speed}
                play={lottieState.play}
                animationData={iconKey}
                direction={lottieState.direction}
                segments={lottieState.segments}
                style={{ width: '100%', height: '100%', alignSelf: 'center' }}
                // onComplete={() => addLog('complete')}
                // onLoopComplete={() => addLog('loopComplete')}
                // onEnterFrame={() => {
                //   /* addLog('enterFrame') */
                // }}
                // onSegmentStart={() => addLog('segmentStart')}
                // onLoad={() => addLog('load')}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InputConfirmBox;
